module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PARTONE"
    }
  }, [_vm._v("PART ONE"), _c('br'), _vm._v("\n  Biblical Patterns: "), _c('span', {
    staticClass: "bi"
  }, [_vm._v("Story-Shaped Liturgy")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SSWCh1"
    }
  }, [_vm._v("1: Genesis and the Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2: Worship and Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Worship and Sacred Space")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: The Shape of Biblical Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: Worship By The Book")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: Worship and Holiness")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: Worship in Exile, Synagogues and the Early Church")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PARTTWO",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO"), _c('br'), _vm._v("\n  Historical Patterns: "), _c('span', {
    staticClass: "bi"
  }, [_vm._v("The Interpretations of Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Early Patterns for Christian Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Reformation Patterns for Christian Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SSWCh10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: Contemporary Patterns for Christian Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/FurtherReading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SubjectIndex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ScriptureIndex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Endorsements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endorsements")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0